import { Grid } from '@mui/material';
import { useEffect } from 'react';
import { FormControl } from '../../../../../../../ui/components/pure/form-control/form-control.component';
import { TextField } from '../../../../../../../ui/components/pure/text-field/text-field.component';
import { useBookOrderActionContext } from '../../book-order-action.context';
import { SectionTitle } from '../../shared-components/section-title/section-title.component';
import { Dropdown, DropdownOption } from '../../../../../../../ui/components/pure/dropdown/dropdown.component';
import { LockerSelector } from '../locker-selector/locker-selector.component';
import { BookingFlowType } from '../../../../../../../ui/enums/booking-flow-type.enum';

interface OrderDetailsFormProps {
  hubSelectOptions: DropdownOption<string>[];
}

export function OrderDetailsForm({ hubSelectOptions }: OrderDetailsFormProps) {
  const { bookOrderStepForm, bookingFlowType } = useBookOrderActionContext();
  const hubID = bookOrderStepForm.watch('bookOrderForm.hubID');

  // Clear lockerID when hubID changes for inventory flow
  useEffect(() => {
    if (bookingFlowType === BookingFlowType.INVENTORY) {
      const currentLockerID = bookOrderStepForm.getValues('bookOrderForm.lockerID');
      if (currentLockerID) {
        bookOrderStepForm.setValue('bookOrderForm.lockerID', '');
      }
    }
  }, [hubID, bookingFlowType, bookOrderStepForm]);
  return (
    <Grid container sx={{ flexDirection: 'column' }} spacing={1}>
      <Grid>
        <SectionTitle gutterBottom value="Order" />
      </Grid>
      <Grid
        container
        spacing={2}
        sx={{
          alignItems: 'flex-end'
        }}
      >
        <Grid
          size={{
            xs: 12,
            md: 12,
            lg: 6
          }}
        >
          <FormControl
            control={bookOrderStepForm.control}
            name="bookOrderForm.orderNumber"
            Component={TextField}
            ComponentProps={{
              textFieldVariant: 'floating' as const,
              placeholder: 'Retailer order number',
              fullWidth: true,
              required: false,
              desktopWidth: '100%'
            }}
          />
        </Grid>

        {(hubSelectOptions.length > 1 || bookingFlowType === BookingFlowType.INVENTORY) && (
          <Grid
            size={{
              xs: 12,
              md: 12,
              lg: 6
            }}
          >
            <FormControl
              control={bookOrderStepForm.control}
              name="bookOrderForm.hubID"
              Component={Dropdown}
              rules={{
                required: bookingFlowType === BookingFlowType.INVENTORY ? 'Please select a hub' : false
              }}
              ComponentProps={{
                fullWidth: true,
                required: bookingFlowType === BookingFlowType.INVENTORY,
                textFieldDesktopWidth: '100%',
                dropdownVariant: 'floating' as const,
                placeholder: 'Hub',
                menuItems: hubSelectOptions
              }}
            />
          </Grid>
        )}
      </Grid>

      {bookingFlowType === BookingFlowType.INVENTORY && (
        <Grid style={{ marginTop: 16 }}>
          <LockerSelector hubID={hubID} required={true} />
        </Grid>
      )}
    </Grid>
  );
}
